module.exports = __webpack_public_path__ + "media/images/ny-a7f39f1a4bc6c3f40d407f1cef0b200f.png";